<template>
    <aside class="language-picker">
        <div class="language-picker__active">
            <img src="~@/assets/img/icons/languages/ru.svg" class="language-picker__image" alt="language">
        </div>
    </aside>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="scss">
.language-picker {
  &__image {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
  }

  &__active {
    overflow: hidden;
  }
}
</style>
